import {Observable, tap} from "rxjs";
import {inject, Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import { AuthService } from '../auth.service';
import {HttpClient, HttpHeaders} from "@angular/common/http";

type RetourAPI = {
  token: string;
  code: string;
};

@Injectable({
  providedIn: 'root'
})
export class AuthOrdoclicService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private token: string | null = null;
  private code: string | null = null;

  getToken(): string | null {
    return this.token;
  }

  getCode(): string | null {
    return this.code;
  }

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  generateSignature(rpps: number): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .post<RetourAPI>(`${environment.api.gateway}ordoclic/generatetoken`,
        {rpps: rpps.toString()},
        {headers: headers})
      .pipe(
        tap((RetourAPI) => (this.token = RetourAPI.token)),
      );
  }

  authenticateCode(): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .post<RetourAPI>(`${environment.api.gateway}ordoclic/authenticatecode`,
        {ordoclictoken: this.token},
        {headers: headers})
      .pipe(
        tap((RetourAPI) => (this.code = RetourAPI.code)),
      );
  }

  createProfesionnal(data: any, signature: any): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .post<any>(`${environment.api.gateway}ordoclic/createprofessionnal`,
        {
          ordoclictoken: this.token,
          data: data,
          signature: signature
        },
        {headers: headers})
      .pipe(
        tap((response) => (response)),
      );
  }

}
